<template>
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            :trackCode="trackCode"
          />
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <slot name="headerPosition" />
        </div>
      </template>
      <template #main="{ height }">
        <slot name="mainTable" :height="height" />
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
  </div>
</template>

<script>
import { getQueryBodyList } from '@/api/counting';

export default {
  name: 'CheckListBaseBox',
  props: {
    queryFormDefault: {
      type: Object,
      default: () => ({
        countingDateStart: '', // 开始时间
        countingDateEnd: '', // 结束时间
        page: 1,
        limit: 20,
        channelType: '',
        confirmStatus: '',
        merchantName: '',
        transType: 2,
        timeType: '1',
      }),
    },
    queryFormList: {
      type: Array,
      default: () => ([]),
    },
    total: {
      type: Number,
      default: 0,
      require: true,
    },
    loading: {
      type: Boolean,
      default: false,
      require: true,
    },
    timeParams: {
      type: Array,
      default: () => (['countingDateStart', 'countingDateEnd']),
    },
    trackCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      queryForm: JSON.parse(JSON.stringify(this.queryFormDefault)),
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '账单日期', value: '1' },
          ],
          dateProps: {
            beginTime: this.timeParams[0],
            endTime: this.timeParams[1],
          },
        },
        {
          label: '对账主体',
          prop: 'merchantName',
          component: 'input',
        },
        ...this.queryFormList,
      ],
      selectList: [
        {
          title: '对账所属渠道',
          prop: 'channelType',
          dictionaryPath: '/finance/finance-counting/CountingChannelEnum',
          attrs: {
            style: { maxWidth: '150px' },
          },
        },
        {
          title: '是否确认',
          prop: 'confirmStatus',
          dictionaryPath: '/common/general/whether',
        },
      ],
      parentMerchantOptions: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getParentMerchantOptions() {
      try {
        const res = await getQueryBodyList({ transType: 1 });
        this.parentMerchantOptions = res.data || [];
        this.parentMerchantOptions.unshift({
          merchantNo: '',
          merchantName: '全部',
        });
      } catch (error) {
        this.parentMerchantOptions = [];
        console.log(error);
      }
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },

    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    getList() {
      this.$emit('getList', this.queryForm);
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(this.queryFormDefault));
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>
